import { Omit } from "react-router";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import {
  ContractCreateOneflowContract,
  ContractCreateOneflowContractProps,
} from "./ContractCreateOneflowContract";

type Props = Omit<AppModalProps, "children"> & {
  subProps: ContractCreateOneflowContractProps;
};

export function ContractCreateOneflowContractModal({ subProps, ...dialogProps }: Props) {
  return (
    <AppModal fullWidth maxWidth='md' {...dialogProps}>
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>Create Oneflow contract</AppModalTitle>
          <AppModalContent>
            {params.isOpen && (
              <ContractCreateOneflowContract
                {...subProps}
                onCancel={() => {
                  params.close();
                  subProps?.onCancel();
                }}
                onSave={(...args) => {
                  params.close();
                  subProps?.onSave(...args);
                }}
              />
            )}
          </AppModalContent>
        </>
      )}
    </AppModal>
  );
}
